import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import { FONT_VARIANT } from '../../../../../../../components/fonts/font-props';
import { Badge, BadgeType } from '../../../../../../../components/badge/badge';

import { OrderEligibilityDisplayService, ItemEligibilityDto, PolicyEvaluation } from '../../order-eligibility-display.service';

import FailedChecksSection from './failed-checks-section';

interface PolicyItemProps {
    item: ItemEligibilityDto;
    policy: PolicyEvaluation;
}

const PolicyItem: React.FC<PolicyItemProps> = ({ item, policy }) => {
    const policyEvaluation = item.policy_evaluations.find(evaluation => evaluation.policy_id === policy.policy_id);
    const isEligible = policyEvaluation?.is_eligible || false;
    const failedChecks = policyEvaluation?.eligibility_checks.filter(check => !check.is_passed) || [];

    return (
        <div key={item.line_item_id} className={`policy-item ${isEligible ? 'eligible' : 'ineligible'}`}>
            <div className="policy-item-header">
                <FontBody2 variant={[FONT_VARIANT.BOLD]}>
                    {OrderEligibilityDisplayService.formatItemTitle(item)}
                </FontBody2>
                <Badge 
                    type={isEligible ? BadgeType.SUCCESS : BadgeType.WARNING}
                    text={isEligible ? 'Eligible' : 'Ineligible'}
                />
            </div>
            
            {/* Show failed checks for this policy */}
            {!isEligible && policyEvaluation && (
                <FailedChecksSection 
                    failedChecks={failedChecks}
                    resolutionCategory={policyEvaluation.resolution?.resolution_category}
                />
            )}
        </div>
    );
};

export default PolicyItem;
